var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeoff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6827 17.94C16.9733 19.243 14.8918 19.9649 12.7427 20C5.74268 20 1.74268 12 1.74268 12C2.98657 9.68192 4.71181 7.65663 6.80268 6.06003M10.6427 4.24002C11.331 4.0789 12.0357 3.99836 12.7427 4.00003C19.7427 4.00003 23.7427 12 23.7427 12C23.1357 13.1356 22.4117 14.2048 21.5827 15.19M14.8627 14.12C14.588 14.4148 14.2568 14.6512 13.8888 14.8151C13.5208 14.9791 13.1236 15.0673 12.7208 15.0744C12.318 15.0815 11.9178 15.0074 11.5443 14.8565C11.1707 14.7056 10.8314 14.4811 10.5465 14.1962C10.2616 13.9113 10.0371 13.572 9.88618 13.1984C9.7353 12.8249 9.6612 12.4247 9.66831 12.0219C9.67542 11.6191 9.76358 11.2219 9.92755 10.8539C10.0915 10.4859 10.3279 10.1547 10.6227 9.88003",
    stroke: "#3A3B3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74268 1L23.7427 23",
    stroke: "#3A3B3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.742676)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoff);
export default __webpack_public_path__ + "static/media/eyeoff.c46127a989a810409912f52c42f8fc8b.svg";
export { ForwardRef as ReactComponent };